import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseTableComponent } from '../base-table/base-table.component';
import { Category } from 'src/app/entities/category';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { CategoryService } from 'src/app/services/category.service';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class CategoryComponent extends BaseTableComponent<Category> implements OnInit {

  displayedColumns = ['id', 'title', 'is_feature', 'status', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    },
    {
      key: 'title',
      field_key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: ''
    },
    {
      key: 'is_feature',
      field_key: 'is_feature',
      type: 'option',
      title: 'Destacado',
      classes: '',
      options: {
        '0': {
          title: 'NO'
        },
        '1': {
          title: 'SI'
        },
      }
    },
    {
      key: 'status',
      field_key: 'status',
      type: 'option',
      title: 'Estado',
      classes: '',
      options: {
        '0': {
          title: 'Inactiva'
        },
        '1': {
          title: 'Activa'
        },
      }
    },
  ];

  constructor(
    protected categoryService: CategoryService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = categoryService;
  }

  ngOnInit(): void {
    this.loadItems();
  }

  
  onSearch() {
    if (this.filterSearch != '') {
      this.tableModel.addwhereLike('category.title', this.filterSearch);
    } else{
      this.tableModel.resetWhere();
    }
    this.loadItems();
  }

}
